module.exports = __webpack_public_path__ + "img/avatar.fa87be1b.svg";